export const formatPastedCareProviderPhoneNumber = (input: string) => {
  const isPhoneNumberOnly = /^\+.*\d$/.test(input.trim()) //string starts with plus and ends with a digit
  if (isPhoneNumberOnly) {
    //remove (0) and non-numeric characters except +
    return input.replace(/\(\s*0\s*\)|[()]|[^0-9+]/g, "")
  }
  return input
}
